import React from "react"
import styled from "styled-components"
import { GridContainer } from "./GridContainer"
import * as Icons from "../icons"
import media from "../../styles/media"
import { Link } from "gatsby"

const FooterWrapper = styled(GridContainer)`
  background-color: ${props => props.theme.black};
  color: ${props => props.theme.white};
  padding: 20px;

  ${media.tablet`
    padding: 20px 40px;
  `}
`

const FooterLeft = styled.div`
  grid-column: 1 / span 2;

  ${media.tablet`
    display: flex;
    grid-column: 1 / span 8;
  `}
`

const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  grid-column: 3 / span 2;
  justify-content: space-between;

  ${media.tablet`
    grid-column: 10 / span 3;
  `}
`

const FooterContent = styled.div`
  align-items: center;
  display: flex;
  font-size: 13px;

  a {
    color: ${props => props.theme.white};
    text-decoration: none;

    &:hover {
      color: ${props => props.theme.red};
    }
  }
`

const IconLink = styled.a`
  &:hover {
    svg {
      g,
      path {
        fill: ${props => props.theme.red};
      }
    }
  }
`

export const Footer = () => {
  return (
    <FooterWrapper>
      <FooterLeft>
        <FooterContent>
          <Link to="/employment">Employment Opportunities</Link>
        </FooterContent>

        <FooterContent
          css={`
            ${media.tablet`
              margin-left: 30px;
            `}
          `}
        >
          <Link to="/terms">Terms &amp; Conditions</Link>
        </FooterContent>

        <FooterContent
          css={`
            ${media.tablet`
              margin-left: 30px;
            `}
          `}
        >
          <Link to="/terms">&copy; 2016 Columbia Artists Management Inc.</Link>
        </FooterContent>
      </FooterLeft>

      <SocialIcons>
        <IconLink
          target="_blank"
          href="https://www.instagram.com/columbia_artists/"
        >
          <Icons.Instagram />
        </IconLink>

        <IconLink
          target="_blank"
          href="https://twitter.com/columbiaartists?lang=en"
        >
          <Icons.Twitter />
        </IconLink>

        <IconLink
          target="_blank"
          href="https://www.facebook.com/ColumbiaArtistsManagement/"
        >
          <Icons.Facebook />
        </IconLink>

        <IconLink
          target="_blank"
          href="https://www.youtube.com/user/TheCAMIChannel/about"
        >
          <Icons.YouTube />
        </IconLink>
      </SocialIcons>
    </FooterWrapper>
  )
}
